<template>
  <div class="modal fade" :id="''+id" data-bs-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <form @submit.prevent="submitChildData" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('access.perimeters.creation') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal" aria-label="Close">
                            <span class="svg-icon svg-icon-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                      fill="currentColor"/>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                      fill="currentColor"/>
                                </svg>
                            </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <Input
                containerClass="col-12 mt-2 mb-5"
                :name="`${id}-name`"
                type="text"
                :label="$t('access.perimeters.name')"
                labelClass="form-label"
                :inputClass="'form-control form-control-lg form-control-solid'"
                :placeholder="$t('access.perimeters.name')"
                :isRequired="true" size="lg"
                v-model="formChildData.name"
            />
            <Select2
                :parent-id="'#'+id"
                containerClass="col-12 mb-5"
                :name="'type'+id"
                :multiple="false"
                :label="$t('access.perimeters.type')"
                labelClass="mb-3"
                selectClass="form-select form-select-solid"
                :isRequired="true"
                :placeholderText="$t('access.perimeters.type_placeholder')"
                v-model="formChildData.type_perimeter_id"
            >
              <option v-for="type in getPerimeterTypes" :key="type.id" :value="type.id">
                {{ type.name }}
              </option>
            </Select2>
            <Select2
                :parent-id="'#'+id"
                containerClass="col-12 mb-5"
                :name="'principal'+id"
                :multiple="false"
                :label="$t('access.perimeters.principal_perimeter')"
                labelClass="mb-3"
                selectClass="form-select form-select-solid"
                :isRequired="false"
                :placeholderText="$t('access.perimeters.principal_perimeter_placeholder')"
                v-model="formChildData.main_perimeter_id"
                :clear="true"
            >
              <option v-for="perimeter in getPerimeters" :key="perimeter.id" :value="perimeter.id">
                {{ perimeter.name }}
              </option>
            </Select2>
            <Select2
                :parent-id="'#'+id"
                containerClass="col-12 mb-5"
                :name="'country'+id"
                :multiple="false"
                :label="$t('access.perimeters.country')"
                labelClass="mb-3"
                selectClass="form-select form-select-solid"
                :isRequired="true"
                :placeholderText="$t('access.perimeters.country_placeholder')"
                v-model="formChildData.office_id"
            >
              <option v-for="office in getOffices" :key="office.id" :value="office.id">
                {{ office.name }}
              </option>
            </Select2>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingPerimeterChild"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import {ref, defineProps, computed, onMounted, watch} from 'vue'
import {useStore} from "vuex";
import RequiredText from "@/components/RequiredText"
import Button from "@/components/Button.vue"
import Input from "@/components/Input.vue";
import Select2 from "@/components/Select2.vue";

const store = useStore()

const props = defineProps({
  form: {
    type: Object,
    default: {
      id: '',
      name: '',
      type_perimeter_id: '',
      office_id: '',
      main_perimeter_id: ''
    }
  },
  id: {
    type: String,
    required: true
  },
  parent: {
    type: String,
    required: false
  }
})

const emits = defineEmits(['load'])

const formChildData = ref(props.form)
const isLoadingPerimeterChild = ref(false)

const currentCompanyId = computed(() => store.getters['offices/getSelectCompanyId'])
const getOffices = computed(() => store.getters['offices/getOffices'])
const getPerimeters = computed(() => store.getters['perimeters/getMainPerimeters'])
const getPerimeterTypes = computed(() => store.getters['perimeterTypes/getPerimeterTypes'])

watch(() => props.form, (value) => {
  formChildData.value = props.form
}, { deep: true })

watch(() => currentCompanyId.value, () => {
  if(currentCompanyId.value) store.dispatch('offices/loadSocietyOffices', currentCompanyId.value);
})

function submitChildData(){
  isLoadingPerimeterChild.value = true

  store.dispatch('perimeters/createPerimeter', formChildData.value)
      .then((response) => {
        emits('load', response?.data?.data?.id)
        isLoadingPerimeterChild.value = false
        closeModal()
        formChildData.value.id = ''
        formChildData.value.name = ''
        formChildData.value.type_perimeter_id = ''
        formChildData.value.office_id = ''
        formChildData.value.main_perimeter_id = ''

        window.toastr['success'](i18n.global.t('notification.perimeter_created'))
      })
      .catch(err => {
        isLoadingPerimeterChild.value = false
      })
}

function closeModal(){
  if(props.parent){
    $('#'+props.parent).modal('toggle')
  }
  $('#'+props.id).modal('toggle')
}

onMounted(() => {
  if(currentCompanyId.value) store.dispatch('offices/loadSocietyOffices', currentCompanyId.value);
  store.dispatch("perimeterTypes/loadPerimeterTypes")
  store.dispatch("perimeters/loadMainPerimeters")
})
</script>